// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/work-levels",
  ListShort: "/pyr/companies/{OrgId}/work-levels/short",
  Create: "/pyr/companies/{OrgId}/work-levels",
  Update: "/pyr/companies/{OrgId}/work-levels",
};
